export function ContractResearchIcon({ className }: { className?: string }) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      className={className}
    >
      <path
        d="M16.3333 2.33334V7.00001C16.3333 8.28781 17.3788 9.33334 18.6666 9.33334H23.3333"
        stroke="currentColor"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.97941 24.5C5.39517 25.2201 6.16273 25.6646 6.99425 25.6667H21.0001C22.2879 25.6667 23.3334 24.6211 23.3334 23.3333V8.16668L17.5001 2.33334H7.00008C5.71228 2.33334 4.66675 3.37888 4.66675 4.66668V8.16668"
        stroke="currentColor"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 21L8.75 19.25"
        stroke="currentColor"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.33325 16.3333C2.33325 18.265 3.90155 19.8333 5.83325 19.8333C7.76495 19.8333 9.33325 18.265 9.33325 16.3333C9.33325 14.4016 7.76495 12.8333 5.83325 12.8333C3.90155 12.8333 2.33325 14.4016 2.33325 16.3333V16.3333"
        stroke="currentColor"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
